import { useEffect, useState } from "react";
import Lastmenu from "./LastMenu";
import you from '../images/boy.png'
import bot from '../images/happy.png';
import LoadingDots from "./LoadingDots";

const Contact = () => {
    const [loading, setLoading] = useState(true);
          
              useEffect(() => {
                  setTimeout(() => setLoading(false), 1000);
              }, []);
               const [time] = useState(new Date())
return(
    <>
     <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time.toLocaleTimeString()}
            </div>
            
            <div className="you-message">
                <div className="frame2 animated-frame">Contact Us</div>
            </div>

    {loading ? (<div className='frame1 animated-frame'><LoadingDots /></div>) : 
    <>
    <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'> {time.toLocaleTimeString()}</div>
            </div>
    <div className="frame1 animated-frame">
        
            <b style={{marginTop: '5px'}}>Contact Us</b><br></br>
            Toll Free No - 1800 103 4343<br></br>
            Office No - +91 422 4073000<br></br>
            Mail Id - corporate@akaayfeeds.com<br></br><br></br>
            <b style={{marginTop: '5px'}}>Registered Address</b><br></br>
            Akaay Feeds Pvt Ltd
            6th Floor, Jaya Enclave,
            1057, Avinashi Rd,
            Coimbatore – 641 018.<br></br><br></br>
            <b style={{marginTop: '5px'}}>Corporate Address</b><br></br>
            Akaay Feeds Pvt Ltd
            2nd Floor, UNITEA Building,
            No: 3, Savithri Shanmugam Road,
            Race Course, Coimbatore – 641 018.    
        </div>
         <Lastmenu />
         </>
}
   
    </>
);
}
export default Contact;
